import { render } from "./pre_orders_analisys.vue?vue&type=template&id=38d70ff6&scoped=true"
import script from "./pre_orders_analisys.vue?vue&type=script&lang=js"
export * from "./pre_orders_analisys.vue?vue&type=script&lang=js"

import "./pre_orders_analisys.vue?vue&type=style&index=0&id=38d70ff6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38d70ff6"]])

export default __exports__